// ----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------------
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class InfoBuffer {
    lookup(entryName) {
        return this.record[entryName];
    }
    remove(entryName) {
        this.record[entryName] = undefined;
    }
    create(entryName, info) {
        if (this.record[entryName]) {
            return false;
        }
        this.record[entryName] = info;
        return true;
    }
    update(entryName, info) {
        if (!this.record[entryName]) {
            return false;
        }
        this.record[entryName] = info;
        return true;
    }
    constructor(name){
        _define_property(this, "name", void 0);
        _define_property(this, "record", void 0);
        this.name = name || 'instrument.core.InfoBuffer';
        this.record = {};
    }
}
export class AggregationBuffer {
    increase(entryName) {
        this.record[entryName] += 1;
        let action = this.callback['increase'];
        if (action) {
            action.apply(this, [
                entryName,
                this.record[entryName]
            ]);
        }
        return true;
    }
    add(entryName, size) {
        this.record[entryName] += size;
        let action = this.callback['add'];
        if (action) {
            action.apply(this, [
                entryName,
                this.record[entryName]
            ]);
        }
        return true;
    }
    empty(entryName) {
        if (!this.record[entryName]) {
            return false;
        }
        this.record[entryName] = 0;
        let action = this.callback['empty'];
        if (action) {
            action.apply(this, [
                entryName,
                this.record[entryName]
            ]);
        }
        return true;
    }
    addEntry(entryName) {
        if (this.record[entryName]) {
            return false;
        }
        this.record[entryName] = 0;
        return true;
    }
    constructor(name){
        _define_property(this, "name", void 0);
        _define_property(this, "record", void 0);
        _define_property(this, "callback", void 0);
        this.name = name || 'instrument.core.AggregationBuffer';
        this.record = {};
        this.callback = {};
    }
}
export class Buffer {
    push(item) {
        if (this.overflow && this.size + 1 > this.length) {
            this.overflow(this.data[(this.end + 1) % this.length], this);
        }
        this.data[(this.end + 1) % this.length] = item;
        if (this.size < this.length) {
            if (this.size + 1 > this.length) {
                this.size = this.length;
            } else {
                this.size += 1;
            }
        }
        this.end = (this.end + 1) % this.length;
        this.start = (this.length + this.end - this.size + 1) % this.length;
        return this.size;
    }
    pop() {
        if (this.size === 0) {
            return null;
        }
        let item = this.data[this.end];
        delete this.data[this.end];
        this.end = (this.end - 1 + this.length) % this.length;
        this.size--;
        return item;
    }
    firstItem() {
        return this.data[this.start];
    }
    lastItem() {
        return this.data[this.end];
    }
    getItem(index) {
        return this.data[(this.start + index) % this.length];
    }
    setItem(index, item) {
        this.data[(this.start + index) % this.length] = item;
    }
    isEmpty() {
        return this.size === 0;
    }
    isFull(additionalSize = 0) {
        return this.getLength() + additionalSize > this.size;
    }
    setOverflow(overflow) {
        this.overflow = overflow;
    }
    getLength() {
        return this.length;
    }
    getSize() {
        return this.size;
    }
    getEnd() {
        return this.end;
    }
    empty() {
        this.size = this.start = 0;
        this.end = this.length - 1;
        return this;
    }
    jsondump() {
        return JSON.stringify(this.data);
    }
    constructor(length){
        _define_property(this, "name", void 0);
        _define_property(this, "data", void 0);
        _define_property(this, "size", void 0);
        _define_property(this, "length", void 0);
        _define_property(this, "start", void 0);
        _define_property(this, "end", void 0);
        _define_property(this, "overflow", void 0);
        this.name = 'instrument.core.Buffer';
        this.data = [];
        this.size = 0;
        this.overflow = null;
        this.start = 0;
        this.end = 0;
        this.length = length;
    }
}
